import { Select } from "antd";
export const SearchSelectUI = ({ handleSearch, data, ...restProps }) => {
  return (
    <Select
      showSearch
      defaultActiveFirstOption={false}
      filterOption={false}
      onSearch={handleSearch}
      notFoundContent={null}
      options={data}
      {...restProps}
    />
  );
};
